<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />

    <div id="contents" class="clearfix">
      <div id="main_area">
        <div class="information">
          <h3>B202 刪除申報表</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tr>
                <td>申報年度</td>
                <td colspan="3">
                  <select v-model="form.sYear">
                    <option
                      v-for="(data, index) in dropDownList.syears"
                      :key="index"
                      :value="data"
                    >
                      {{ data }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>身分證統一編號</td>
                <td>
                  <input type="text" size="10" maxlength="10" v-model="form.idn"/>
                </td>
              </tr>
              <tr>
                <td>姓名</td>
                <td>
                  <input name="textfield3" size="40" maxlength="49" v-model="form.name"/>
                </td>
              <tr>
                <td colspan="6" class="f_center">
                  <input
                    type="submit"
                    class="btn"
                    value="查詢"
                    @click="doQuery()"
                  />
                  <input
                    type="submit"
                    class="btn"
                    value="重填"
                    @click="doClear()"
                  />
                </td>
              </tr>
            </table>
          </div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%">
            <tr>
              <td></td>
              <td v-if="grid.paginaiton" align="right">
                <input
                  type="button"
                  value="<<"
                  class="btn"
                  style="height: 28px"
                  @click="form.currentpage = grid.paginaiton.pageNo - 1"
                  v-show="grid.paginaiton.pageNo > 1"
                />
                <span
                  v-for="(data, index) in grid.paginaiton.pages"
                  :key="index"
                  style="cursor: pointer"
                  :style="
                    grid.paginaiton.pageNo == data ? 'color:red' : 'color:black'
                  "
                  @click="form.currentpage = parseInt(data)"
                >
                  {{ grid.paginaiton.pageNo == data ? "[" + data + "]" : data }}
                </span>
                <input
                  type="button"
                  class="btn"
                  value=">>"
                  style="height: 28px"
                  v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                  @click="form.currentpage = grid.paginaiton.pageNo + 1"
                />
                ［每頁<input
                  type="text"
                  v-model.number.lazy="form.pagesize"
                  maxlength="4"
                  size="2"
                />

                <input type="button" class="btn" value="筆" />，第<input
                  type="text"
                  v-model.number.lazy="form.currentpage"
                  maxlength="4"
                  size="2"
                />
                <input type="button" class="btn" value="頁" />，共
                {{ grid.paginaiton.totalPage }} 頁
                {{ grid.paginaiton.totalCount }} 筆］
              </td>
            </tr>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th>操作</th>
                    <th>姓名</th>
                    <th>身分證字號</th>
                    <th>申報年度</th>
                    <th>申報日期</th>
                    <th>申報類別</th>
                    <th>申報表名稱</th>
                    <th>上傳時間</th>
                    <th>刪除註記</th>
                    <th>序號</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="刪"
                        @click="btnDelete(data)"
                      />
                    </td>
                    <td>{{data.name}}</td>
                    <td>{{data.idn}}</td>
                    <td>{{data.syear}}</td>
                    <td>{{data.sdate}}</td>
                    <td>{{data.dtype}}</td>
                    <td>{{data.kind}}</td>
                    <td>{{data.datetime}}</td>
                    <td>{{data.delflag}}</td>
                    <td>{{data.seqno}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>

    <CyFooter />

    <Alert v-model="Alert.show" :title="Alert.title" :ServiceUnit="pageData.ServiceUnit">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>

    <Confirm v-model="Confirm.show" :title="Confirm.title" :ServiceUnit="pageData.ServiceUnit">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Confirm.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Confirm.BtnOK">確定</button>
          <button class="btn" @click="Confirm.BtnCancel">取消</button>
        </div>
      </div>
    </Confirm>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import CyFooter from "@/components/Common/CyFooter.vue";
import { getMenuIndex } from "@/config/util.js";
import
{
  B202_SearchGrid,
  B202_Delete
} from "@/service/api.js";

export default {
  name: "B202",
  data: function () {
    return {
      pageData: {
        MenuIndex: 1,
        PrgName: "B202",
        ServiceUnit: "CY",
        isForceLoginOut : true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      form: {
        sYear: "",
        idn: "",
        name: "",
        currentpage: 1,
        pagesize: 10,
      },
      dropDownList: {
        syears: [],
      },
      grid: {},
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.Alert.show = false;
        },
      },
      Confirm: {
        show: false,
        title: "",
        txt: [],
        BtnOK: function () {
          this.Confirm.show = false;
        },
        BtnCancel: function () {
          this.Confirm.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    CyFooter,
    Alert: VueModal,
    Confirm: VueModal,
  },
  methods: {
    getSyearDropDownList: function () {
      let syears = [""];
      const startYear = 99;
      for (let i = startYear; i <= new Date().getFullYear() - 1911; i++) {
        syears.push(i.toString().length === 2 ? "0" + i : i.toString());
      }
      return syears;
    },
    //查詢
    doQuery: function () {
      const self = this;
      let postData = {
        sYear: self.form.sYear,
        idn: self.form.idn,
        name: self.form.name,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo:{
            Id:self.loginInfo.id,
            PrgCode:self.pageData.PrgName,
            ActCd:"查詢",
            ServiceUnit:self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          }
      };
      B202_SearchGrid(postData).then((rData) => {
        self.grid = rData.returnObject;
      });
    },
    doClear: function (data) {
      const self = this;
      self.form.sYear = "";
      self.form.idn = "";
      self.form.name = "";
    },
    btnDelete: function(data){
      const self = this;
      self.Confirm.show = true;
      self.Confirm.txt = ["請確定是否刪除??"];
      self.Confirm.title = "訊息";
      self.Confirm.BtnOK = function(){ self.Delete(data);  self.Confirm.show = false;};
      self.Confirm.BtnCancel = function(){ self.Confirm.show = false;};
    },
    Delete: function (data) {
      const self = this;
      let formData = {
        seqno:data.seqno,
        LogInfo:{
            Id:self.loginInfo.id,
            PrgCode:self.pageData.PrgName,
            ActCd:"刪除",
            ServiceUnit:self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          }
      };
      B202_Delete(formData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["刪除成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.form.Selected = [];
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["刪除失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    self.pageData.MenuIndex = getMenuIndex(self.pageData.PrgName);
    if (self.pageData.MenuIndex === null) {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.dropDownList.syears = self.getSyearDropDownList();
    self.doQuery();
  },
  watch:{
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
  },
};
</script>

<style scoped src="@/assets/css/Cy.css" />
